<div class="school-header" [class.mobile]="deviceService.isMobile()" [class.tablet]="deviceService.isTablet()">
  <div class="header-cover-wrap">
    <on-ui-cover [cover]="headCover"></on-ui-cover>
  </div>

  <div class="top-wrap">
    <div class="cover-wrap" (click)="isModal ? navigateToSchoolPage() : null">
      <on-ui-cover [cover]="cover"></on-ui-cover>
    </div>

    <ng-container *ngIf="!deviceService.isMobile()">
      <ng-container *ngTemplateOutlet="actions"></ng-container>
    </ng-container>
  </div>

  <div class="info-wrap">
      <div class="info" (click)="isModal ? navigateToSchoolPage() : null">
        <div class="status">
        <p class="title" [class.has-subtitle]="!shortDescription">{{ title }}</p>
        <ng-template [ngIf]="hasVerifiedSchool" [ngIfElse]="noVerified">
          <app-icon class="verify-icon verify" file="status" icon="teacher-verify"></app-icon>
        </ng-template>

        <ng-template #noVerified>
          <app-icon class="verify-icon no-verify" file="status" icon="teacher-no-verify"></app-icon>
        </ng-template>
        </div>
        <p class="sub-title" [innerHTML]="shortDescription"></p>
      </div>
      <div class="stats">
        <div *ngFor="let stat of stats; let last = last; trackBy: trackByFn" class="stat">
          <span class="stat-title label">{{ stat.title | customLocale }}</span>
          <ng-template class="icon-wrap" [ngIf]="stat.name === 'reviews_rating'">
            <app-icon [height]="16" [width]="16" [icon]="stat.icon" class="star-icon"></app-icon>
          </ng-template>
          <span class="stat-title" [class.review]="stat.name === 'reviews_rating'">{{ stat.value | numberRound }}</span>
          <span *ngIf="!last" class="point"></span>
        </div>
        <div class="stat" *ngIf="school.rating">
          <span class="point"></span>
          <app-rating [stats]="school" [label]="true"></app-rating>
        </div>
      </div>
    <ng-template [ngIf]="!deviceService.isMobile()">
      <ng-container *ngTemplateOutlet="teachingWrap"></ng-container>
    </ng-template>
  </div>

  <ng-container *ngIf="deviceService.isMobile()">
    <ng-container *ngTemplateOutlet="actions"></ng-container>
    <ng-container *ngTemplateOutlet="teachingWrap"></ng-container>
  </ng-container>
</div>

<ng-template #teachingWrap>
  <div class="scroll" [class.mobile-subjects]="deviceService.isMobile()">
    <div class="teaching-wrap">
      <div *ngFor="let teach of subjects; trackBy: trackByFn"
           [class.active]="teach.id == subjectId"
           (click)="onNavigateToSubject(teach)"
           class="teaching-subject-item">
        <span class="subject-title">{{ getSubjectTitle(teach) }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #actions>
  <div class="actions">
    <ng-template [ngIf]="hasTeachersInSchool && (meIsOwnerSchool || meIsTeacherSchool)">
      <div class="action-item">
        <on-ui-button class="transparent"
                      (click)="onToggleMeetingForm()"
                      label="school-header.actions.schedule">
        </on-ui-button>
      </div>
    </ng-template>
    <ng-template [ngIf]="false && (meIsOwnerSchool || meIsTeacherSchool || meIsStudentSchool)">
      <div class="action-item">
        <on-ui-button class="primary outline"
                      label="school-header.actions.chat">
        </on-ui-button>
      </div>
    </ng-template>
    <ng-template [ngIf]="!meIsOwnerSchool && !meIsTeacherSchool && !meIsStudentSchool">
      <div class="action-item">
        <on-ui-button class="primary outline"
                      [state]="addParticipantActionState"
                      label="school-header.actions.join"
                      (onclick)="onAddParticipant()">
        </on-ui-button>
      </div>
    </ng-template>

    <ng-template [ngIf]="meIsOwnerSchool || meIsTeacherSchool">
      <div class="action-item">
        <div class="participant">
          <on-ui-button class="status"
                        [label]="meIsOwnerSchool ? 'school-header.status.owner' : (meIsTeacherSchool ? 'school-header.status.tutor' : '')">
          </on-ui-button>
        </div>
      </div>
    </ng-template>

    <div class="actions-wrap" *ngIf="meIsStudentSchool && !meIsTeacherSchool && !meIsOwnerSchool">
      <on-ui-button class="primary outline"
                    label="school-header.status.student"
                    iconPosition="after"
                    (onclick)="onOpenActionsPopup()">
        <app-icon
          class="action-icon"
          [width]="10"
          [height]="10"
          file="chevron"
          icon="down">
        </app-icon>
      </on-ui-button>
      <div class="actions-menu" *ngIf="openActionsPopup">
        <p (click)="onToggleAlertLeaveSchool(); openActionsPopup=false">
          {{ 'school-header.leave.alert-leave' | customLocale }}
        </p>
      </div>
    </div>
    <ng-template [ngIf]="isModal">
      <div class="action-item">
        <on-ui-button class="primary"
                      label="school-card.actions.enter"
                      (onclick)="navigateToSchoolPage()">
        </on-ui-button>
      </div>
    </ng-template>
    <div class="top-actions">
      <ng-template [ngIf]="meIsOwnerSchool">
        <a [routerLink]="settingsUrl" class="action-link">
          <app-icon width="24" height="24" icon="gear" ></app-icon>
        </a>
      </ng-template>

      <div class="copy-informer" [class.active]="copied"><span>{{'invite-card.link-copied' | customLocale}}</span></div>
      <app-bookmark [item]="school" type="school" (favoriteChanged)="onFavoriteChanged()"></app-bookmark>
      <on-ui-card-menu>
        <ng-template [ngIf]="meIsOwnerSchool" [ngIfElse]="all">
          <div class="menu-item"
               #shareLinkRef
               [ngxClipboard]
               [cbContent]="fullSchoolUrl"
               (cbOnSuccess)="onCopied()"
               [container]="shareLinkRef">{{ 'school-card.actions.share' | customLocale }}</div>
          <div class="menu-item" (click)="onToggleForm()">{{ 'school-card.actions.edit' | customLocale }}</div>
          <div class="menu-item" (click)="onToggleAlert()">{{ 'school-card.actions.delete' | customLocale }}</div>
        </ng-template>
        <ng-template #all>
          <div class="menu-item"
               #shareLinkRef
               [ngxClipboard]
               [cbContent]="fullSchoolUrl"
               (cbOnSuccess)="onCopied()"
               [container]="shareLinkRef">{{ 'school-card.actions.share' | customLocale }}</div>
          <div class="menu-item" (click)="onToggleComplainForm()">{{ 'school-card.actions.complain' | customLocale }}</div>
        </ng-template>
      </on-ui-card-menu>
    </div>
  </div>
</ng-template>

<app-modal *ngIf="!deviceService.isMobile() && schoolForm" (closed)="onToggleForm()">
  <app-modal-body>
    <app-school-form [modalDisplayMode]="true" [school]="school" (changed)="changed($event)"></app-school-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="deviceService.isMobile() && schoolForm" (closed)="onToggleForm()">
  <app-mobile-modal-title>{{ 'school-form.header' | customLocale }}</app-mobile-modal-title>
  <app-mobile-modal-body>
    <app-school-form [modalDisplayMode]="true" [school]="school" (changed)="changed($event)"></app-school-form>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-modal *ngIf="!deviceService.isMobile() && meetingForm" (closed)="onToggleMeetingForm()">
  <app-modal-body>
    <app-meeting-form-wrapper [caller]="'app-school-header'"></app-meeting-form-wrapper>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="deviceService.isMobile() && meetingForm" (closed)="onToggleMeetingForm()">
  <app-mobile-modal-title>{{ 'school-form.header' | customLocale }}</app-mobile-modal-title>
  <app-mobile-modal-body>
    <app-meeting-form-wrapper [caller]="'app-school-header'"></app-meeting-form-wrapper>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-alert *ngIf="openAlertLeaveSchoolState" type="warning">
  <ng-container alert-title>{{ 'school-header.leave.alert-title' | customLocale }}</ng-container>
  <ng-container alert-body>{{ 'school-header.leave.alert-body' | customLocale }}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button class="primary outline"
                  [label]="'school-header.leave.alert-cancel' | customLocale"
                  (onclick)="onToggleAlertLeaveSchool()">
    </on-ui-button>
    <on-ui-button class="primary"
                  [label]="'school-header.leave.alert-leave' | customLocale"
                  [state]="leaveSchoolState"
                  (onclick)="onLeaveSchool()">
    </on-ui-button>
  </ng-container>
</app-alert>

<app-alert *ngIf="alertOpened" type="error">
  <ng-container alert-title>{{ 'delete-school.header' | customLocale }}</ng-container>
  <ng-container alert-body>{{ 'delete-school.text' | customLocale }}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button class="primary outline"
                  label="delete-school.close"
                  (onclick)="onToggleAlert()">
    </on-ui-button>
    <on-ui-button class="danger"
                  label="delete-school.delete"
                  (onclick)="onRemoveSchool()">
    </on-ui-button>
  </ng-container>
</app-alert>

<app-modal *ngIf="!deviceService.isMobile() && openComplainForm" (closed)="onToggleComplainForm()" middle="true">
  <app-modal-body>
    <app-complaint-form (cancel)="onToggleComplainForm()" [type]="'content'"></app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="deviceService.isMobile() && openComplainForm"
                  (closed)="onToggleComplainForm()"
                  [titleVisible]="false">
  <app-mobile-modal-body>
    <app-complaint-form (cancel)="onToggleComplainForm()" [type]="'content'"></app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>
